export enum PaymentMethod {
    CASH = "cash",
    CARD = "card",
    APP_PAYMENT = "app_payment",
    BUSINESS = "business",
}
